import React, { FC } from 'react';
import { Card, KeyValueList } from '@lithos';

export interface TectonFCOListItem {
  title: React.ReactNode;
  content: React.ReactNode;
}

interface TectonFCOCardProps {
  title: React.ReactNode;
  items: TectonFCOListItem[];
}

const TectonFCOCard: FC<TectonFCOCardProps> = ({ title, items }) => {
  return (
    <Card title={title} data-testid="tecton-card">
      <KeyValueList items={items} />
    </Card>
  );
};

export default TectonFCOCard;
